var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-modal fixed inset-0 flex justify-center items-center p-3 pt-17 md:p-10 md:pt-28 bg-black bg-opacity-75"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }